<div class="box-input escape-confirm">
  <label v-if="label" :for="updatedLabel" class="txt-ellipsis bold">
    {{ updatedLabel && $t(updatedLabel) }}
    <span v-if="required" class="txt-danger txt-required">
      <span>*</span>
    </span>
  </label>
  <div class="row">
    <div
      v-if="type === 'date'"
      :class="isError ? 'outline-error':''"
      class="row"
    >
      <div v-if="readonly" class="input is_readonly">
        {{ $helper?.formatDate(dateValue) }}
      </div>
      <VueDatePicker
        v-else
        v-model="dateValue"
        @click.stop
        @update:modelValue="dateOnChange"
        :min-date="minDate ? new Date(minDate || '') : ''"
        :dark="$store?.state?.appMode === 'dark-mode' ? true : false"
        :placeholder="placeholder ? $t(placeholder) : dateFormat"
        :format="dateFormat"
      />
    </div>
    <input
      v-else-if="readonly"
      :value="value"
      :type="eye ? (isTypeString ? 'text' : 'password') : 'text'"
      :placeholder="placeholder ? $t(placeholder) : 'N/A'"
      :class="[className, { 'outline-danger': isError, 'pl60': type === 'tel', 'pl45': searchable && left, 'pr55': searchable && !left }]"
      :ref="refIds"
      class="input is_readonly"
      v-bind:autocomplete="autocompleteValue"
      readonly
    />
    <input
      v-else
      :value="value"
      @keyup.enter="onEnter"
      @keyup="onKeypress($event)"
      @keypress="onKeypress($event)"
      @change="onKeypress($event)"
      @input="onEmits($event)"
      @keydown="handleKeyDown"
      :type="eye ? (isTypeString ? 'text' : 'password') : (type === 'date' || type === 'timestamp') ? type : 'text'"
      :placeholder="placeholder ? $t(placeholder) : 'N/A'"
      :class="[className, { 'outline-danger': isError, 'pl60': type === 'tel', 'pl45': searchable && left, 'pr55': searchable && !left }]"
      :ref="refIds"
      class="input"
      v-bind:autocomplete="autocompleteValue"
      :min="minDate || ''"
    />
    <!-- <button
      v-if="readonly && value && (type !== 'date')"
      @click="copyToClipboard"
      :tooltip="showPopup ? $t('componentCopied') : $t('componentCopy')"
      class="btn btn-danger btn-xs clone-icon tooltip mr3"
      style="right: 20px; top: 0px; height: 100%"
    >
      <i class="fa fa-clone"></i>
    </button> -->
    <div v-if="eye" class="is-password">
      <img
        v-if="isTypeString"
        @click="isTypeString = !isTypeString"
        :src="require('@/assets/icons/sidebars/eye.svg')"
      />
      <img
        v-else
        @click="isTypeString = !isTypeString"
        :src="require('@/assets/icons/sidebars/close-eye.svg')"
      />
    </div>
    <div v-if="searchable && left" @click="onEnter" class="c-input-btn-search">
      <img :src="require('@/assets/icons/sidebars/search.svg')" alt="" />
    </div>
    <div
      v-if="searchable && !left"
      @click="onEnter"
      class="c-input-btn-search-right"
    >
      <img
        :src="require('@/assets/icons/sidebars/white-search.svg')"
        style="filter: none; opacity: 1"
        alt=""
      />
    </div>
    <div v-if="type == 'tel'" class="tel-prefix">+855</div>
  </div>
  <p v-if="isError && showError" class="mb0 txt-danger font14 mt3">
    <span>{{ $t(isError) }}</span>
  </p>
</div>
